import { JetView } from 'webix-jet';
import {
    devConfig, // Development configuration settings
    countries, // List of countries for selection
    profile, // User profile information
    cashDesks, // Cash desk information
    agentList, // List of agents
} from 'config/config';

/**
 * Class representing a filter view for cash flow summary.
 * @extends JetView
 */
export default class FilterFlujoCajaResumidoView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'Country',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            id: 'Countries',
                            on: {
                                onChange: function (data, obj) {
                                    // Enable/disable button based on selection
                                    var currentValue = this.getValue();
                                    if (currentValue.length > 0 && $$('Type').getValue().length > 0) {
                                        $$('consultDesk').enable();
                                    } else {
                                        $$('consultDesk').disable();
                                    }
                                },
                            },
                        },
                        {
                            view: 'datepicker', // Date picker for initial month
                            name: 'Date',
                            id: 'Date',
                            stringResult: false,
                            minWidth: 200,
                            type: 'month',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Mes Inicial'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: new Date(), // Default to current date
                            format: '%M %Y',
                        },
                        {
                            view: 'datepicker', // Date picker for final month
                            name: 'Date2',
                            stringResult: false,
                            minWidth: 200,
                            type: 'month',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Mes Final'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: new Date(), // Default to current date
                            format: '%M %Y',
                        },
                        {
                            view: 'radio', // Radio buttons for type selection
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 500 || screen.height < 500 ? 90 : 0,
                            options: [
                                { id: 'R', value: _('Totales') }, // Total option
                                { id: 'D', value: _('Detallado') }, // Detailed option
                            ],
                            on: {
                                onChange: function (data, obj) {
                                    // Enable/disable button based on selection
                                    var currentValue = this.getValue();
                                    if (currentValue.length > 0 && $$('Countries').getValue().length > 0) {
                                        $$('consultDesk').enable();
                                    } else {
                                        $$('consultDesk').disable();
                                    }
                                },
                            },
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('flujoCajaResumido:filter', [
                            filterdata, // Trigger filter event
                        ]);
                        $$('b5').collapse(); // Collapse filter section
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    id: 'consultDesk2',
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        this.app.callEvent('flujoCajaResumido:filter', [
                            filterdata, // Trigger filter event
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion on larger screens
                    : { id: 'right2', height: 1, width: screen.width - 54 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (devConfig.getCountryReport()) {
                // Check if country report is enabled
                if (screen.width > 600) {
                    $$('consultDesk').enable(); // Enable button for larger screens
                } else {
                    $$('consultDesk2').enable(); // Enable button for smaller screens
                }
            }
        });
    }
}

// FILE DOCUMENTED
